/* AFIQ bundle PDP (sections/afiq-bundle-main.liquid + afiq-bundle-inside.liquid). Spec: Build/pdp/bundle.js.
   Merchandising (2026-09-30): the full system (Vol 1–4) leads on every bundle page; the page's own smaller
   set is listed last with no tag. Add-ons: Flag Football IQ 5v5 and Football Basics.
   Prices: AFIQ_UI.priceDecks, the cheapest real checkout route (bundle SKU + ladder on the rest, or the
   ladder on everything). Add to cart: AFIQ_UI.addToCart(AFIQ_UI.cartItems(ids, 'pdp-bundle-' + key)). */
(function () {
  'use strict';
  var root = document.querySelector('[data-abun]');
  var UI = window.AFIQ_UI;
  if (!root || !UI) return;

  var P = UI.P, D = UI.D, $ = UI.$, esc = UI.esc, I = UI.I;
  var cfg = JSON.parse(root.querySelector('[data-abun-data]').textContent);
  var L = cfg.labels;
  var key = cfg.key || 'elite', SRC = 'pdp-bundle-' + key;

  /* Which decks this product is: its entry in AFIQ_DATA._meta.bundles, else the section's own list. */
  var meta = (D._meta.bundles || []).filter(function (b) { return b.handle === cfg.handle; })[0];
  var decks = ((meta && meta.decks) || cfg.decks || []).filter(function (id) { return P[id]; });
  var ELITE = ['v1', 'v2', 'v3', 'v4'].filter(function (id) { return P[id]; });
  if (!decks.length || !ELITE.length) return;   // no data: keep the Liquid fallback (adds this bundle SKU)
  var isElite = ELITE.every(function (d) { return decks.indexOf(d) >= 0; });

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cards = function (ids) { return ids.reduce(function (s, id) { return s + (P[id].cards || 54); }, 0); };
  var OWN = meta && meta.sku;  /* this page's own bundle: its option adds this SKU at its real price */
  var price = function (ids) { return UI.priceDecks(ids, OWN); };
  var chk = I.check.replace('class="ic"', 'class="apdp-ic"');

  /* ---------- options: the full system first on every page; this page's own set last, untagged ---------- */
  function options() {
    var eq = price(ELITE);
    var o = [{ key: 'elite', decks: ELITE, title: L.fullOption, short: L.fullShort, note: ELITE.length + ' decks · ' + cards(ELITE) + ' cards', tag: [isElite ? L.mostPopular : L.bestValue, 'red'] }];
    if (!isElite) {
      var diff = eq.total - price(decks).total;
      if (diff > 0) o[0].note += ' · only ' + $(diff) + ' more than ' + cfg.span;
      o.push({ key: 'own', decks: decks, title: cfg.span, short: cfg.span, note: decks.length + ' decks · ' + cards(decks) + ' cards' });
    }
    return o;
  }
  var OPTS = options();
  var ADDONS = [
    { id: 'fl5', title: L.fl5Title, note: L.fl5Note },
    { id: 'basics', title: L.basicsTitle, note: L.basicsNote }
  ].filter(function (a) { return P[a.id] && P[a.id].available; });

  var state = { opt: 'elite', add: {} };
  function opt() { return OPTS.filter(function (o) { return o.key === state.opt; })[0] || OPTS[0]; }
  function added(except) { return ADDONS.filter(function (a) { return state.add[a.id] && a.id !== except; }).map(function (a) { return a.id; }); }
  function selected() { return opt().decks.concat(added()); }

  /* ---------- render ---------- */
  function stackHtml(ids) {
    return ids.map(function (id, i) { return '<img src="' + esc(P[id].cutout) + '" alt="" loading="lazy" style="left:' + i * (ids.length > 3 ? 11 : 15) + 'px;z-index:' + i + '">'; }).join('');
  }
  function optHtml(o) {
    var q = price(o.decks), sel = state.opt === o.key;
    return '<div class="apdp-opt' + (sel ? ' is-sel' : '') + '" data-abun-opt="' + o.key + '" role="radio" aria-checked="' + sel + '" tabindex="' + (sel ? 0 : -1) + '">' +
      (o.tag ? '<span class="apdp-otag is-' + o.tag[1] + '">' + esc(o.tag[0]) + '</span>' : '') +
      '<span class="apdp-radio"></span><span class="apdp-stack">' + stackHtml(o.decks) + '</span>' +
      '<div class="apdp-otx"><b>' + esc(o.title) + '</b><p>' + esc(o.note) + ' · ' + $(q.perDeck) + '/deck</p></div>' +
      '<div class="apdp-price"><b>' + $(q.total) + '</b>' + (q.save > 0 ? '<s>' + $(q.full) + '</s><span class="apdp-save">SAVE ' + $(q.save) + '</span>' : '') + '</div></div>';
  }
  function addonHtml(a) {
    var on = !!state.add[a.id], x = P[a.id], base = opt().decks.concat(added(a.id));
    var extra = price(base.concat(a.id)).total - price(base).total;   // what this add-on adds to the total
    return '<button type="button" class="apdp-addon' + (on ? ' is-on' : '') + '" data-abun-add="' + a.id + '" aria-pressed="' + on + '">' +
      '<span class="apdp-addon-box">' + (on ? chk : '+') + '</span><img src="' + esc(x.cutout) + '" alt="" loading="lazy">' +
      '<span class="apdp-addon-t"><b>' + esc(a.title) + '</b><small>' + esc(a.note) + '</small></span>' +
      '<span class="apdp-addon-p"><b>+' + $(extra) + '</b>' + (extra < x.price ? '<s>' + $(x.price) + '</s>' : '') + '</span></button>';
  }
  function viaNote(ids, q) {
    if (q.bundle) return esc(q.bundle.title) + ' price' + (q.rest.some(function (id) { return P[id].ladder; }) && AFIQ.tier(q.rest.filter(function (id) { return P[id].ladder; }).length).pct ? ' + the multi-deck discount' : '') + ' · you save ' + $(q.save);
    if (q.save > 0) return 'Multi-deck discount · ' + q.pct + '% off every deck · you save ' + $(q.save);
    return '';
  }

  var elOpts = root.querySelector('[data-abun-opts]'), elAdd = root.querySelector('[data-abun-addons]'),
      elAtc = root.querySelector('[data-abun-atc]'), elAtcLabel = root.querySelector('[data-abun-atc-label]'),
      elVia = root.querySelector('[data-abun-via]'), elSticky = root.querySelector('[data-abun-sticky]');
  var available = !elAtc.disabled || ELITE.every(function (id) { return P[id].available; });

  function render(focusKey) {
    var ids = selected(), q = price(ids);
    elOpts.innerHTML = OPTS.map(optHtml).join('');
    elAdd.innerHTML = ADDONS.length ? '<div class="apdp-opt-h"><span class="apdp-eyebrow">Complete the kit</span><small>Optional add-ons</small></div>' + ADDONS.map(addonHtml).join('') : '';
    if (available) { elAtc.disabled = false; elAtcLabel.textContent = 'Add ' + ids.length + ' decks · ' + $(q.total); }
    if (elVia) elVia.textContent = viaNote(ids, q);
    if (elSticky) {
      var nAdd = added().length;
      elSticky.querySelector('[data-abun-sticky-title]').textContent = opt().short + (nAdd ? ' + ' + nAdd : '');
      elSticky.querySelector('[data-abun-sticky-price]').innerHTML = $(q.total) + (q.save > 0 ? ' <s>' + $(q.full) + '</s>' : '');
    }
    if (focusKey) { var f = root.querySelector('[data-abun-opt="' + focusKey + '"]'); if (f) f.focus({ preventScroll: true }); }
  }
  function selectOpt(k, via, focus) {
    if (!OPTS.some(function (o) { return o.key === k; })) return;
    var changed = state.opt !== k; state.opt = k; render(focus ? k : null);
    if (changed) UI.track('afiq_pdp_option', { option: k, via: via || 'buy_box', bundle: key, product: cfg.handle });
  }

  /* ---------- cart ---------- */
  function add(btn) {
    var ids = selected(), ups = added().map(function (id) { return 'b10x-upsell-pdp-' + ({ fl5: 'flag', basics: 'basics' }[id] || id); });
    return UI.addToCart(UI.cartItems(ids, SRC, OWN), SRC, btn).then(function () { if (ups.length && UI.tagUpsell) return UI.tagUpsell(ups); });
  }
  root.querySelector('form.abun-form').addEventListener('submit', function (e) { e.preventDefault(); add(elAtc); });

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-abun-add]');
    if (a) {
      var id = a.getAttribute('data-abun-add'); state.add[id] = !state.add[id]; render();
      var btn = root.querySelector('[data-abun-add="' + id + '"]'); if (btn) btn.focus({ preventScroll: true });
      UI.track('afiq_pdp_addon', { addon: id, on: !!state.add[id], bundle: key, product: cfg.handle });
      return;
    }
    var o = e.target.closest('[data-abun-opt]');
    if (o) { selectOpt(o.getAttribute('data-abun-opt'), 'buy_box', true); return; }
    var th = e.target.closest('[data-apdp-thumb]');
    if (th) { goTo(+th.getAttribute('data-apdp-thumb')); return; }
    if (e.target.closest('[data-apdp-prev]')) { goTo(slideIdx() - 1); return; }
    if (e.target.closest('[data-apdp-next]')) { goTo(slideIdx() + 1); return; }
    var st = e.target.closest('[data-abun-sticky-add]');
    if (st) add(st);
  });
  /* radiogroup keyboard: Enter/Space select, arrows move */
  elOpts.addEventListener('keydown', function (e) {
    var cur = e.target.closest('[data-abun-opt]'); if (!cur) return;
    var i = OPTS.map(function (o) { return o.key; }).indexOf(cur.getAttribute('data-abun-opt'));
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOpt(OPTS[i].key, 'buy_box', true); }
    else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); selectOpt(OPTS[(i + 1) % OPTS.length].key, 'buy_box', true); }
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); selectOpt(OPTS[(i - 1 + OPTS.length) % OPTS.length].key, 'buy_box', true); }
  });
  /* "+ Full system" in the What's inside rows (another section) selects the full-system option */
  document.addEventListener('click', function (e) {
    var l = e.target.closest('[data-abun-opt-link]'); if (!l) return;
    e.preventDefault();
    selectOpt(l.getAttribute('data-abun-opt-link'), 'inside', false);
    var bb = root.querySelector('.apdp-bb');
    if (bb) bb.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    var f = root.querySelector('[data-abun-opt="elite"]'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, reduceMotion ? 0 : 450);
  });

  /* ---------- FAQ price tokens: [elite_total] [elite_full] [elite_save] in the FAQ answers ---------- */
  (function () {
    var eq = price(ELITE), map = { elite_total: $(eq.total), elite_full: $(eq.full), elite_save: $(eq.save) };
    document.querySelectorAll('.apdp-faq-l details > div').forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) if (n.nodeValue.indexOf('[elite_') >= 0) n.nodeValue = n.nodeValue.replace(/\[(elite_total|elite_full|elite_save)\]/g, function (m, k) { return map[k]; });
    });
  })();

  /* ---------- gallery slider (same behaviour as the deck PDP: scroll-snap, thumbs, arrows) ---------- */
  var gTrack = root.querySelector('[data-apdp-track]');
  function slideIdx() { return gTrack ? Math.round(gTrack.scrollLeft / Math.max(1, gTrack.clientWidth)) : 0; }
  function goTo(i) {
    if (!gTrack) return; var n = gTrack.children.length; i = (i + n) % n;
    var from = gTrack.scrollLeft, to = i * gTrack.clientWidth, t0 = performance.now(), dur = 320;
    if (from === to) return;
    if (reduceMotion) { gTrack.scrollLeft = to; return; }
    gTrack.style.scrollSnapType = 'none'; gTrack.style.scrollBehavior = 'auto';
    (function step(now) {
      var k = Math.min(1, (now - t0) / dur), ez = 1 - Math.pow(1 - k, 3);
      gTrack.scrollLeft = from + (to - from) * ez;
      if (k < 1) requestAnimationFrame(step); else { gTrack.style.scrollSnapType = ''; gTrack.style.scrollBehavior = ''; }
    })(t0);
  }
  if (gTrack) {
    var dots = root.querySelectorAll('.apdp-dots span'), idxEl = root.querySelector('[data-apdp-idx]'), raf = 0;
    gTrack.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = slideIdx();
        if (idxEl) idxEl.textContent = i + 1;
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        root.querySelectorAll('[data-apdp-thumb]').forEach(function (b) { b.classList.toggle('is-on', +b.getAttribute('data-apdp-thumb') === i); });
      });
    }, { passive: true });
    gTrack.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') goTo(slideIdx() + 1); if (e.key === 'ArrowLeft') goTo(slideIdx() - 1); });
  }

  /* ---------- mobile sticky bar ---------- */
  function stickyUpd() {
    if (!elSticky) return;
    var show = elAtc.getBoundingClientRect().bottom < 0;
    elSticky.classList.toggle('is-show', show); elSticky.setAttribute('aria-hidden', String(!show));
    var b = elSticky.querySelector('[data-abun-sticky-add]'); if (b) b.tabIndex = show ? 0 : -1;
  }
  window.addEventListener('scroll', stickyUpd, { passive: true });
  function stickyOffset() { // float above a bottom-docked teaser (e.g. Klaviyo), as the deck PDP does
    if (!elSticky) return; var vh = window.innerHeight, off = 0;
    document.querySelectorAll('body div, body section, body aside').forEach(function (n) {
      if (n === elSticky || root.contains(n)) return; var cs = getComputedStyle(n);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = n.getBoundingClientRect(); if (!r.height || r.height > 220 || Math.abs(r.bottom - vh) > 2 || r.width < innerWidth * 0.5) return;
      off = Math.max(off, Math.round(r.height));
    });
    elSticky.style.bottom = off + 'px';
  }
  [400, 1500, 4000].forEach(function (ms) { setTimeout(stickyOffset, ms); });

  render();
  stickyUpd();
})();
